import {ModuleType} from "./ModuleType";

import {Utils} from "./Utils";

export class ModuleUser{

  active = true;
  moduleType = ModuleType.SCHEDULE_MODULE;
  employeeId: string;
  expiryDate: Date;


  _createSpecialElement(propertyName: string, data: any) {
    if ('moduleType' === propertyName) {
      this.moduleType = ModuleType.retrieveFromCode(data);
      return true;
    }
    return false;
  }

  get isActive(): boolean{
    if (this.active){
      if (!Utils.isNullOrUndefined(this.expiryDate)){
        if (Utils.isToday(this.expiryDate) || Utils.isBeforeToday(this.expiryDate)){
            return false;
        }
      }
      return true;
    }
    return false;
  }


}
